<template>
  <div class="register-box">
    <div class="register-head">
      <img src="@/assets/head-logo.png"/>诚云·工资条
    </div>
    <div class="register-main">
      <el-form :model="registerForm" ref="registerForm" :rules="rules" label-position="right" label-width="88px"
               class="register-container">
        <h2 class="title">账号注册</h2>
        <el-form-item label="企业名称" prop="userName">
          <el-input type="text" v-model="registerForm.userName" auto-complete="off" placeholder="请输入企业名称/组织名称"></el-input>
        </el-form-item>
        <el-form-item label="登录账号" prop="mobileNum">
          <el-input v-model="registerForm.mobileNum" auto-complete="off" placeholder="请输入手机号码作为登录账号"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="verificationCode" class="code">
          <el-input v-model="registerForm.verificationCode" placeholder="请输入验证码"></el-input>
          <el-button :disabled='isDisabled' @click="sendCode" class="register-getcode">{{buttonText}}</el-button>
        </el-form-item>
        <el-form-item label="密码" prop="passWord">
          <el-input type="password" v-model="registerForm.passWord" auto-complete="off" placeholder="请设置登录密码"></el-input>
        </el-form-item>
        <el-form-item style="width:100%;margin-bottom:10px;">
          <el-button type="primary" @click="submitForm">立 即 注 册</el-button>
        </el-form-item>
        <router-link to='Login'><button class="register-goLogin">已有账号？立即登录</button></router-link>
      </el-form>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Register',
    data() {
        //手机号校验
        let checkPhone = (rule,value,callback)=>{
            const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
            if (value === '') {
                callback(new Error('请输入手机号码作为登录账号'))
            } else if (!reg.test(value)) {
                callback(new Error('请输入手机号码作为登录账号'))
            } else {
                callback()
            }
        };
        // 验证码是否为空
        let checkSmscode = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入验证码'))
            } else {
                callback()
            }
        };
        // 验证密码
        let validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请设置登录密码"))
            }else{
                callback()
            }
        };
        return {
            loading: false,
            registerForm: {
              userName:'',
              mobileNum: "",
              verificationCode: "",
              passWord: ""
            },
            rules: {
              userName: [
                { required: true, message: '请输入企业名称/组织名称', trigger: 'blur' },
                { min:4, max:30, message: '长度为4-30个字符', trigger: 'blur' }
              ],
              mobileNum: [{required: true, validator: checkPhone, trigger: 'change' }],
              verificationCode: [{required: true, validator: checkSmscode, trigger: 'change' }],
              passWord: [
                {required: true, validator: validatePass, trigger: 'change' },
                { min:6, max:20, message: '登录密码必须为6-20位', trigger: 'change'}
              ],
            },
            buttonText: '发送验证码',
            isDisabled: false, // 是否禁止点击发送验证码按钮
            flag: true
        }
    },
    methods: {
        // 发送验证码
        sendCode () {
          let tel = this.registerForm.mobileNum;
          let checkMobile =  /^1[3|4|5|7|8][0-9]\d{8}$/;
          if(!tel){
              this.$message({message:'请输入有效的手机号码',type: 'error'});
          }else if(!checkMobile.test(tel)){
              this.$message({message:'手机号码无效，请重新输入',type: 'error'});
          }else{
              let time = 120;
              this.buttonText = '已发送';
              this.isDisabled = true;
              if (this.flag) {
                  this.flag = false;
                  this.$api.login.getCode({phoneNo:tel}).then((res) => {
                      if(res.status) {
                          let timer = setInterval(() => {
                              time--;
                              this.buttonText = time + ' 秒';
                              if (time === 0) {
                                  clearInterval(timer);
                                  this.buttonText = '重新获取';
                                  this.isDisabled = false;
                                  this.flag = true;
                              }
                          }, 1000)
                      } else {
                          this.$message({message: '获取失败, ' + res.msg, type: 'error'})
                      }
                  });
              }
          }
        },
        // 提交注册
        submitForm() {
          this.$refs.registerForm.validate((valid) => {
            if (valid) {
              this.$api.login.registerUser(this.registerForm).then((res) => {
                  if(res.status) {
                      this.$message({message: '注册成功！', type: 'success'});
                      setTimeout(() => {
                          this.$router.replace('/Login');
                      },600);
                  } else {
                      this.$message({message: '操作失败, ' + res.msg, type: 'error'})
                  }
              })
            }
          })
        },
    },
    created() {
      let that = this;
      document.onkeypress = function(e) {
        var keycode = document.all ? event.keyCode : e.which;
        if (keycode === 13) {
          that.submitForm();// 登录方法名
          return false;
        }
      };
    },
    mounted() {},
    computed:{}
  }
</script>

<style lang="scss" scoped>
  .register-box{
    height:100%;
    overflow:hidden;
  }
  .register-head{
    width:1000px;
    margin:0 auto;
    font-size:24px;
    color:#2B2B2B;
    line-height:70px;
    text-align: left;
    font-weight:bold;
    img{
      width:51px;
      vertical-align:middle;
      margin:-8px 10px 0 0;
    }
  }
  .register-main{
    height:680px;
    background:#ecf6f8;
  }
  .register-container {
    margin: 0 auto;
    padding-top:60px;
    width:372px;
    .title {
      margin: 0 auto 30px;
      text-align: center;
      color:#454545;
      font-size:20px;
      padding-left:60px;
    }
    .el-form-item{
      margin-bottom:20px;
    }
    .el-button--primary{
      background-color:#2BA5F6;
      border-color:#2BA5F6;
      width:99%;
    }
    .register-getcode{
      width:auto !important;
      position: absolute;
      top:0;
      right:0;
      background:inherit;
      border:none;
      color:#4DBDF1;
    }
    .register-goLogin{
      color:#2BA5F6;
      border: none;
      background: none;
      cursor: pointer;
      font-size:12px;
      padding-left:60px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/Register.vue